import { useMutation, useQuery } from "react-query";
import { RequestService } from "../services/requests-service";
import { cacheKey } from "./cacheStateKey";

export const useRequestService = () => {
	const useGetAccessRequests = (page = 0, pageSize = 50, serch?: string) => {
		const result = useQuery({
			queryKey: [cacheKey.accessRequests, page, serch],
			queryFn: () => RequestService.getAccessRequests(page, pageSize, serch),
			keepPreviousData: true,
		});
		return result;
	};


	const useGetAccessRequestStats = () => {
		const result = useQuery({
			queryKey: [cacheKey.accessRequestStats],
			queryFn: () => RequestService.getRequestStats(),
		});
		return result;
	};

	const useApproveRequest = () => {
		const result = useMutation(RequestService.approveRequest);
		return result;
	};

	const useEnableRequest = () => {
		const result = useMutation(RequestService.enableRequest);
		return result;
	};

	const useGetRequestTasks = (requestId: string) => {
		const result = useQuery({
			queryKey: [cacheKey.accessRequestTasks, requestId],
			queryFn: () => RequestService.getRequestTasks(requestId),
			keepPreviousData: true,
		});
		return result;
	};

	const useGetRequestHistory = (requestId: string) => {
		const result = useQuery({
			queryKey: [cacheKey.accessRequestTaskHistory, requestId],
			queryFn: () => RequestService.getRequestHistory(requestId),
			keepPreviousData: true,
		});
		return result;
	};

	const useGetRequestComments = (requestId: string, page, pageSize) => {
		const result = useQuery({
			queryKey: [cacheKey.accessRequestComments, requestId],
			queryFn: () =>
				RequestService.getRequestComments(requestId, page, pageSize),
			keepPreviousData: true,
		});
		return result;
	};

	const useCreateRequestComment = () => {
		const result = useMutation(RequestService.createRequestComment);
		return result;
	};

	const useProcessTasks = () => {
		const result = useMutation(RequestService.processTask);
		return result;
	};

  const useRetryAction = () => {
    const result = useMutation(RequestService.retryTask);
		return result;
  }
	return {
		useGetAccessRequests,
		useGetAccessRequestStats,
		useApproveRequest,
		useEnableRequest,
		useGetRequestTasks,
		useGetRequestHistory,
		useGetRequestComments,
		useCreateRequestComment,
		useProcessTasks,
    useRetryAction
	};
};
